import type { CSSProperties, HTMLAttributes } from "react";

export type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  width?: number | string;
  height?: number | string;
  count?: number;
};

export function Skeleton({
  width,
  height,
  count = 1,
  style,
  className,
  ...rest
}: SkeletonProps) {
  const merged: CSSProperties = {
    ...(width !== undefined
      ? { width: typeof width === "number" ? `${width}px` : width }
      : null),
    ...(height !== undefined
      ? { height: typeof height === "number" ? `${height}px` : height }
      : null),
    ...style,
  };
  const cls = ["skeleton", className].filter(Boolean).join(" ");
  if (count === 1) return <div className={cls} style={merged} {...rest} />;
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={cls} style={merged} {...rest} />
      ))}
    </>
  );
}
